import React from "react";

const AnimatedSectionContainer = ({ children }) => {
  // Convert children to array to handle them individually
  const childrenArray = React.Children.toArray(children);

  return (
    <section className="bg-brandBackground py-16">
      <div className="max-w-7xl mx-auto">
        {childrenArray.map((child, index) => (
          <div key={index} className={index !== 0 ? "mt-8 md:mt-[40px]" : ""}>
            {child}
          </div>
        ))}
      </div>
    </section>
  );
};

export default AnimatedSectionContainer;
